import { EntityNotes } from '@tunasong/editor'
import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'

/**
 * Performance-mode wrapper around `EntityNotes`. Shows every note attached to the
 * current entity — same set as the normal-editor right-rail "My Notes" tool — so the
 * user always finds their notes regardless of which surface they were created from.
 *
 * The wrapper still stamps newly created notes with `noteType: 'performance'`. That
 * field is preserved as metadata for future filtering / categorization features; it
 * does not gate visibility in v1.
 *
 * Privacy is unchanged — the underlying `EntityNotes` creates notes with
 * `isPrivate: true`.
 */
export const PerformanceNotes: FC<SidebarComponent> = props => (
  <EntityNotes {...props} defaultNoteType="performance" showTitle />
)

export default PerformanceNotes
